/**
 * D-2026-09-04 — el ⌘K, en un solo lugar.
 *
 * 🔴 EL HUECO QUE TAPA, MEDIDO EN PANTALLA (no en el codigo): dentro de la casa del proyecto
 *    se apretaba ⌘K y **no pasaba nada**. El listener vivia dentro de `Topbar`, `Topbar` vive
 *    dentro de `AppLayout`, y la casa esta FUERA de `AppLayout` a proposito —trae su propio
 *    riel de 52px justo para no tener dos menus—. Al sacarla, se llevo el ⌘K sin que nadie lo
 *    notara. Mismo error que las 7 pantallas sin puerta: la casa se puso en la ruta antes de
 *    traerse todo lo que la ruta daba.
 *
 * 🔑 El atajo se define UNA vez. Topbar y la casa llaman a este hook; si manana cambia a otra
 *    tecla, cambia en los dos a la vez y no hay forma de que se separen.
 */
import { useEffect } from 'react';

export function useAtajoComandos(alternar: () => void): void {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        alternar();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [alternar]);
}
